import SHPLG1 from './SHPLG-1.js';
import SHPLGS from './SHPLG-S.js';
import SHPLGU1 from './SHPLG-U1.js';
import SHSW1 from './SHSW-1.js';
import SHSW1S from './SHSW-1S.js';
import SHSWPM from './SHSW-PM.js';
import SHSWL from './SHSW-L.js';
import SHDW1 from './SHDW-1.js';
import SHRGBWW01 from './SHRGBWW-01.js';
import SHBLB1 from './SHBLB-1.js';
import SHPLGUK1 from './SHPLG-UK1.js';
import SHPLGAU1 from './SHPLG-AU1.js';
import SHSW21 from './SHSW-21.js';
import SHSW22 from './SHSW-22.js';
import SHSW25 from './SHSW-25.js';
import SHSW44 from './SHSW-44.js';
import SHAIR1 from './SHAIR-1.js';
import SHUNI1 from './SHUNI-1.js';
import SHEM3 from './SHEM-3.js';
import SHEM from './SHEM.js';
import SHSEN1 from './SHSEN-1.js';
import SHGS1 from './SHGS-1.js';
import SHMOS01 from './SHMOS-01.js';
import SHMOS02 from './SHMOS-02.js';
import SHSM01 from './SHSM-01.js';
import SHHT1 from './SHHT-1.js';
import SHWT1 from './SHWT-1.js';
import SHCL255 from './SHCL-255.js';
import SH2LED1 from './SH2LED-1.js';
import SHDM1 from './SHDM-1.js';
import SHDIMW1 from './SHDIMW-1.js';
import SHVIN1 from './SHVIN-1.js';
import SHBDUO1 from './SHBDUO-1.js';
import SHCB1 from './SHCB-1.js';
import SHBTN1 from './SHBTN-1.js';
import SHIX31 from './SHIX3-1.js';
import PLG1NB from './PLG1NB.js';
import SMK1NB from './SMK1NB.js';
import DS1NB from './DS1NB.js';
import MS1NB from './MS1NB.js';
import HT1NB from './HT1NB.js';
import WS1NB from './WS1NB.js';
import SNSWdevX16EU from './SNSW-devX16EU.js';
import SNSW001X16EU from './SNSW-001X16EU.js';
import SNSL0A1X03WWL from './SNSL-0A1X03WWL.js';
import IR_REM0 from './IR_REM-0.js';
import SHPLG21 from './SHPLG2-1.js';
import SHDW2 from './SHDW-2.js';
import SHBTN2 from './SHBTN-2.js';
import SHRGBW2 from './SHRGBW2.js';
import SHDM2 from './SHDM-2.js';
import SHTRV01 from './SHTRV-01.js';
export const Gen1 = {
	'SHPLG-1': SHPLG1,
	'SHPLG-S': SHPLGS,
	'SHPLG-U1': SHPLGU1,
	'SHSW-1': SHSW1,
	'SHSW-1S': SHSW1S,
	'SHSW-PM': SHSWPM,
	'SHSW-L': SHSWL,
	'SHDW-1': SHDW1,
	'SHRGBWW-01': SHRGBWW01,
	'SHBLB-1': SHBLB1,
	'SHPLG-UK1': SHPLGUK1,
	'SHPLG-AU1': SHPLGAU1,
	'SHSW-21': SHSW21,
	'SHSW-22': SHSW22,
	'SHSW-25': SHSW25,
	'SHSW-44': SHSW44,
	'SHAIR-1': SHAIR1,
	'SHUNI-1': SHUNI1,
	'SHEM-3': SHEM3,
	SHEM: SHEM,
	'SHSEN-1': SHSEN1,
	'SHGS-1': SHGS1,
	'SHMOS-01': SHMOS01,
	'SHMOS-02': SHMOS02,
	'SHSM-01': SHSM01,
	'SHHT-1': SHHT1,
	'SHWT-1': SHWT1,
	'SHCL-255': SHCL255,
	'SH2LED-1': SH2LED1,
	'SHDM-1': SHDM1,
	'SHDIMW-1': SHDIMW1,
	'SHVIN-1': SHVIN1,
	'SHBDUO-1': SHBDUO1,
	'SHCB-1': SHCB1,
	'SHBTN-1': SHBTN1,
	'SHIX3-1': SHIX31,
	PLG1NB: PLG1NB,
	SMK1NB: SMK1NB,
	DS1NB: DS1NB,
	MS1NB: MS1NB,
	HT1NB: HT1NB,
	WS1NB: WS1NB,
	'SNSW-devX16EU': SNSWdevX16EU,
	'SNSW-001X16EU': SNSW001X16EU,
	'SNSL-0A1X03WWL': SNSL0A1X03WWL,
	// 'SH3EM-003CXCEU63': SH3EM003CXCEU63,
	'IR_REM-0': IR_REM0,
	'SHPLG2-1': SHPLG21,
	'SHDW-2': SHDW2,
	'SHBTN-2': SHBTN2,
	SHRGBW2: SHRGBW2,
	'SHDM-2': SHDM2,
	'SHTRV-01': SHTRV01,
};
